import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-informes-index',
  templateUrl: './informes-index.component.html',
  styleUrls: ['./informes-index.component.scss']
})
export class InformesIndexComponent  {

  TipoUsuario = TipoUsuario;
  
  constructor(private authService: AuthService) { }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }
}
